export const BatchCycleStatus = {
  START: 'START',
  START_LOAD: 'START LOAD',
  START_AGG_FEED: 'START AGG FEED',
  START_CEM_FEED: 'START CEM FEED',
  START_WATER_FEED: 'START WATER FEED',
  LOAD_READY_FOR_DISCHARGE: 'LOAD READY FOR DISCHARGE',
  DISCHARGE_BUTTON_PRESS: 'DISCHARGE BUTTON PRESS',
  START_DISCHARGING: 'START DISCHARGING',
  START_AGG_DISCHARGE: 'START AGG DISCHARGE',
  START_CEM_DISCHARGE: 'START CEM DISCHARGE',
  START_WATER_DISCHARGE: 'START WATER DISCHARGE',
  FINISH: 'FINISH',
  FINISH_LOAD: 'FINISH LOAD',
};
